import React from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-8">
          {children}
        </main>
      </div>
      <footer className="bg-white border-t border-gray-200 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex justify-between items-center text-sm text-gray-500">
            <div>
              DCMS - Document and Content Management System
            </div>
            <div className="flex items-center gap-4">
              <a href="https://github.com" className="hover:text-gray-900 transition-colors">
                GitHub
              </a>
              <a href="/docs" className="hover:text-gray-900 transition-colors">
                Documentation
              </a>
              <a href="/api" className="hover:text-gray-900 transition-colors">
                API
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
